module.exports = __webpack_public_path__ + "static/ollamh_harp-f418ce20ef8fa5b910756c9958f39eb8.jpg";